// extracted by mini-css-extract-plugin
export var root = "typography-module--root--3cac1";